import {useContext, useEffect, useState} from 'react'

import PropTypes from 'prop-types'

import {htmlStringToReactElement} from '@s-ui/js/lib/react'
import AtomActionButton, {atomActionButtonSizes, atomActionButtonStyles} from '@s-ui/react-atom-action-button'
import {atomIconColors, atomIconSizes} from '@s-ui/react-atom-icon'
import AtomImage from '@s-ui/react-atom-image'
import Context from '@s-ui/react-context'
import MoleculeCarousel from '@s-ui/react-molecule-carousel'
import IconCheck from '@adv-mt/mt-svg-icons/lib/Check.js'
import IconChevronLeft from '@adv-mt/mt-svg-icons/lib/ChevronLeft.js'
import IconChevronRight from '@adv-mt/mt-svg-icons/lib/ChevronRight.js'
import IconCircle from '@adv-mt/mt-svg-icons/lib/DummyCircleSmallSolid.js'
import TitleBasic, {titleBasicSizes} from '@adv-mt/mt-title-basic'

import {SLIDES_LENGTH} from '../config.js'

const noop = () => {}

const sliderOptions = {
  hasArrows: false,
  isFullHeight: false,
  isFullWidth: false,
  defaultSlide: 0,
  numOfSlides: 1,
  onSlideAfter: noop,
  slide: 0
}

export const ModalStepsContent = ({isSeller = false, onSlideChange = noop}) => {
  const {domain, i18n} = useContext(Context)
  const [currentSlide, setCurrentSlide] = useState(0)

  useEffect(() => {
    onSlideChange(currentSlide)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentSlide])

  const urlStaticsImages = domain.get('config').get('URL_STATICS_IMAGES')

  const literalUser = isSeller ? 'SELLER' : 'BUYER'

  return (
    <>
      <MoleculeCarousel
        {...sliderOptions}
        arrowLeftLabel={i18n.t('COMMON.PREVIOUS')}
        arrowRightLabel={i18n.t('COMMON.NEXT')}
        slide={currentSlide}
        onInit={noop}
      >
        <div className="mt-ModalTransactionDiscover-stepsImageWrapper">
          <AtomImage
            alt={i18n.t('SECURE_PAYMENT.CARD.SECURE_PAYMENT')}
            className="mt-ModalTransactionDiscover-stepsImage"
            src={`${urlStaticsImages}illustrations/transaction-success.svg`}
          />
        </div>
        <div className="mt-ModalTransactionDiscover-stepsImageWrapper">
          <AtomImage
            alt={i18n.t('SECURE_PAYMENT.CARD.SECURE_PAYMENT')}
            className="mt-ModalTransactionDiscover-stepsImage"
            src={`${urlStaticsImages}illustrations/buyer-verify-account.svg`}
          />
        </div>
        <div className="mt-ModalTransactionDiscover-stepsImageWrapper">
          <AtomImage
            alt={i18n.t('SECURE_PAYMENT.CARD.SECURE_PAYMENT')}
            className="mt-ModalTransactionDiscover-stepsImage"
            src={`${urlStaticsImages}illustrations/tramites-y-servicios.svg`}
          />
        </div>
        <div className="mt-ModalTransactionDiscover-stepsImageWrapper">
          <AtomImage
            alt={i18n.t('SECURE_PAYMENT.CARD.SECURE_PAYMENT')}
            className="mt-ModalTransactionDiscover-stepsImage"
            src={`${urlStaticsImages}illustrations/transaction-safe-payment.svg`}
          />
        </div>
      </MoleculeCarousel>
      <div className="mt-ModalTransactionDiscover-slider">
        <AtomActionButton
          disabled={currentSlide === 0}
          icon={<IconChevronLeft />}
          onClick={() =>
            setCurrentSlide(previous => {
              return previous > 0 ? previous - 1 : 0
            })
          }
          size={atomActionButtonSizes.LARGE}
          style={atomActionButtonStyles.OUTLINE}
        />
        <div className="mt-ModalTransactionDiscover-sliderDots">
          {new Array(SLIDES_LENGTH).fill(null).map((_, index) => {
            return (
              <IconCircle
                color={index === currentSlide ? atomIconColors.primary : atomIconColors.gray}
                key={index}
                onClick={() => setCurrentSlide(index)}
                size={atomIconSizes.medium}
              />
            )
          })}
        </div>
        <AtomActionButton
          disabled={currentSlide === SLIDES_LENGTH - 1}
          icon={<IconChevronRight />}
          onClick={() =>
            setCurrentSlide(previous => {
              return previous < SLIDES_LENGTH - 1 ? previous + 1 : SLIDES_LENGTH - 1
            })
          }
          size={atomActionButtonSizes.LARGE}
          style={atomActionButtonStyles.OUTLINE}
        />
      </div>
      <MoleculeCarousel
        {...sliderOptions}
        arrowLeftLabel={i18n.t('COMMON.PREVIOUS')}
        arrowRightLabel={i18n.t('COMMON.NEXT')}
        isFullHeight
        slide={currentSlide}
        onInit={noop}
      >
        <div className="mt-ModalTransactionDiscover-stepsContent">
          <TitleBasic
            size={titleBasicSizes.s}
            title={i18n.t(`VEHICLE_TRANSACTION.ONBOARDING_STEPS.${literalUser}.STEP_1.TITLE`)}
          />
          <span>
            <strong>{i18n.t(`VEHICLE_TRANSACTION.ONBOARDING_STEPS.${literalUser}.STEP_1.SUBTITLE`)}</strong>
          </span>
          <div className="mt-ModalTransactionDiscover-claims mt-ModalTransactionDiscover-claims--smallGap">
            <div className="mt-ModalTransactionDiscover-claim">
              <div className="mt-ModalTransactionDiscover-claimIcon">
                <IconCheck size={atomIconSizes.medium} />
              </div>
              <div className="mt-ModalTransactionDiscover-claimText mt-ModalTransactionDiscover-claimText--bigger">
                {i18n.t(`VEHICLE_TRANSACTION.ONBOARDING_STEPS.${literalUser}.STEP_1.CLAIM_1`)}
              </div>
            </div>
            <div className="mt-ModalTransactionDiscover-claim">
              <div className="mt-ModalTransactionDiscover-claimIcon">
                <IconCheck size={atomIconSizes.medium} />
              </div>
              <div className="mt-ModalTransactionDiscover-claimText mt-ModalTransactionDiscover-claimText--bigger">
                {i18n.t(`VEHICLE_TRANSACTION.ONBOARDING_STEPS.${literalUser}.STEP_1.CLAIM_2`)}
              </div>
            </div>
            <div className="mt-ModalTransactionDiscover-claim">
              <div className="mt-ModalTransactionDiscover-claimIcon">
                <IconCheck size={atomIconSizes.medium} />
              </div>
              <div className="mt-ModalTransactionDiscover-claimText mt-ModalTransactionDiscover-claimText--bigger">
                {i18n.t(`VEHICLE_TRANSACTION.ONBOARDING_STEPS.${literalUser}.STEP_1.CLAIM_3`)}
              </div>
            </div>
          </div>
        </div>
        <div className="mt-ModalTransactionDiscover-stepsContent">
          <TitleBasic
            size={titleBasicSizes.s}
            title={i18n.t(`VEHICLE_TRANSACTION.ONBOARDING_STEPS.${literalUser}.STEP_2.TITLE`)}
          />
          <span>{i18n.t(`VEHICLE_TRANSACTION.ONBOARDING_STEPS.${literalUser}.STEP_2.SUBTITLE_2`)}</span>
          <span>
            <strong>{i18n.t(`VEHICLE_TRANSACTION.ONBOARDING_STEPS.${literalUser}.STEP_2.SUBTITLE`)}</strong>
          </span>
          <div className="mt-ModalTransactionDiscover-claims mt-ModalTransactionDiscover-claims--smallGap">
            <div className="mt-ModalTransactionDiscover-claim">
              <div className="mt-ModalTransactionDiscover-claimIcon">
                <IconCheck size={atomIconSizes.medium} />
              </div>
              <div className="mt-ModalTransactionDiscover-claimText mt-ModalTransactionDiscover-claimText--bigger">
                {htmlStringToReactElement(
                  i18n.t(`VEHICLE_TRANSACTION.ONBOARDING_STEPS.${literalUser}.STEP_2.CLAIM_1`, {
                    highlightEnd: '</strong>',
                    highlightStart: '<strong>'
                  })
                )}
              </div>
            </div>
            <div className="mt-ModalTransactionDiscover-claim">
              <div className="mt-ModalTransactionDiscover-claimIcon">
                <IconCheck size={atomIconSizes.medium} />
              </div>
              <div className="mt-ModalTransactionDiscover-claimText mt-ModalTransactionDiscover-claimText--bigger">
                {htmlStringToReactElement(
                  i18n.t(`VEHICLE_TRANSACTION.ONBOARDING_STEPS.${literalUser}.STEP_2.CLAIM_2`, {
                    highlightEnd: '</strong>',
                    highlightStart: '<strong>'
                  })
                )}
              </div>
            </div>
            <div className="mt-ModalTransactionDiscover-claim">
              <div className="mt-ModalTransactionDiscover-claimIcon">
                <IconCheck size={atomIconSizes.medium} />
              </div>
              <div className="mt-ModalTransactionDiscover-claimText mt-ModalTransactionDiscover-claimText--bigger">
                {i18n.t(`VEHICLE_TRANSACTION.ONBOARDING_STEPS.${literalUser}.STEP_2.CLAIM_3`)}
              </div>
            </div>
          </div>
        </div>
        <div className="mt-ModalTransactionDiscover-stepsContent">
          <TitleBasic
            size={titleBasicSizes.s}
            title={i18n.t(`VEHICLE_TRANSACTION.ONBOARDING_STEPS.${literalUser}.STEP_3.TITLE`)}
          />
          <span>
            <strong>{i18n.t(`VEHICLE_TRANSACTION.ONBOARDING_STEPS.${literalUser}.STEP_3.SUBTITLE`)}</strong>
          </span>
          <div className="mt-ModalTransactionDiscover-claims mt-ModalTransactionDiscover-claims--smallGap">
            <div className="mt-ModalTransactionDiscover-claim">
              <div className="mt-ModalTransactionDiscover-claimIcon">
                <IconCheck size={atomIconSizes.medium} />
              </div>
              <div className="mt-ModalTransactionDiscover-claimText mt-ModalTransactionDiscover-claimText--bigger">
                {htmlStringToReactElement(
                  i18n.t(`VEHICLE_TRANSACTION.ONBOARDING_STEPS.${literalUser}.STEP_3.CLAIM_1`, {
                    highlightEnd: '</strong>',
                    highlightStart: '<strong>'
                  })
                )}
              </div>
            </div>
            <div className="mt-ModalTransactionDiscover-claim">
              <div className="mt-ModalTransactionDiscover-claimIcon">
                <IconCheck size={atomIconSizes.medium} />
              </div>
              <div className="mt-ModalTransactionDiscover-claimText mt-ModalTransactionDiscover-claimText--bigger">
                {htmlStringToReactElement(
                  i18n.t(`VEHICLE_TRANSACTION.ONBOARDING_STEPS.${literalUser}.STEP_3.CLAIM_2`, {
                    highlightEnd: '</strong>',
                    highlightStart: '<strong>'
                  })
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="mt-ModalTransactionDiscover-stepsContent">
          <TitleBasic
            size={titleBasicSizes.s}
            title={i18n.t(`VEHICLE_TRANSACTION.ONBOARDING_STEPS.${literalUser}.STEP_4.TITLE`)}
          />
          <span>
            <strong>{i18n.t(`VEHICLE_TRANSACTION.ONBOARDING_STEPS.${literalUser}.STEP_4.SUBTITLE`)}</strong>
          </span>
          <div className="mt-ModalTransactionDiscover-claims mt-ModalTransactionDiscover-claims--smallGap">
            <div className="mt-ModalTransactionDiscover-claim">
              <div className="mt-ModalTransactionDiscover-claimIcon">
                <IconCheck size={atomIconSizes.medium} />
              </div>
              <div className="mt-ModalTransactionDiscover-claimText mt-ModalTransactionDiscover-claimText--bigger">
                {htmlStringToReactElement(
                  i18n.t(`VEHICLE_TRANSACTION.ONBOARDING_STEPS.${literalUser}.STEP_4.CLAIM_1`, {
                    highlightEnd: '</strong>',
                    highlightStart: '<strong>'
                  })
                )}
              </div>
            </div>
            <div className="mt-ModalTransactionDiscover-claim">
              <div className="mt-ModalTransactionDiscover-claimIcon">
                <IconCheck size={atomIconSizes.medium} />
              </div>
              <div className="mt-ModalTransactionDiscover-claimText mt-ModalTransactionDiscover-claimText--bigger">
                {htmlStringToReactElement(
                  i18n.t(`VEHICLE_TRANSACTION.ONBOARDING_STEPS.${literalUser}.STEP_4.CLAIM_2`, {
                    highlightEnd: '</strong>',
                    highlightStart: '<strong>'
                  })
                )}
              </div>
            </div>
            {!isSeller && (
              <div className="mt-ModalTransactionDiscover-claim">
                <div className="mt-ModalTransactionDiscover-claimIcon">
                  <IconCheck size={atomIconSizes.medium} />
                </div>
                <div className="mt-ModalTransactionDiscover-claimText mt-ModalTransactionDiscover-claimText--bigger">
                  {htmlStringToReactElement(
                    i18n.t(`VEHICLE_TRANSACTION.ONBOARDING_STEPS.${literalUser}.STEP_4.CLAIM_3`, {
                      highlightEnd: '</strong>',
                      highlightStart: '<strong>'
                    })
                  )}
                </div>
              </div>
            )}
          </div>
          <span>
            <strong>{i18n.t(`VEHICLE_TRANSACTION.ONBOARDING_STEPS.${literalUser}.STEP_4.TEXT`)}</strong>
          </span>
        </div>
      </MoleculeCarousel>
    </>
  )
}

ModalStepsContent.displayName = 'ModalStepsContent'
ModalStepsContent.propTypes = {
  isSeller: PropTypes.bool,
  onSlideChange: PropTypes.func
}
